/* global window */
import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import ForgotPasswordForm from 'profile/login/forms/ForgotPasswordFormNoRoutes';
import LoginForm from 'profile/login/forms/LoginFormNoRoutes';
import MagicLinkForm from 'profile/login/forms/MagicLinkFormNoRoutes';
import { getCustomer } from 'redux/customer/actions';

class LoginForms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: 'Login'
    };
  }

  componentDidMount() {
    const { props } = this;
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  handleLogin = () => {
    this.setState({
      form: 'Login'
    });
  };

  handleForgotPassword = () => {
    this.setState({
      form: 'ForgotPassword'
    });
  };

  handleMagicLink = () => {
    this.setState({
      form: 'MagicLink'
    });
  };

  render() {
    const { redirectTo, customer } = this.props;
    if (!redirectTo) {
      return <>Invalid tag useage. Must have a data-redirect-to attribute.</>;
    }
    if (Cookies.get('customerToken') && customer.isFetching) {
      // Dont show the form yet - because we are seeing if we have a customer
      return null;
    }
    if (Cookies.get('customerToken') && customer.data) {
      window.location.replace(redirectTo);
      return null;
    }

    const { form } = this.state;
    switch (form) {
      case 'Login': {
        return (
          <>
            <LoginForm
              redirectLink={redirectTo}
              onForgotPassword={this.handleForgotPassword}
              onMagicLink={this.handleMagicLink}
            />
          </>
        );
      }
      case 'ForgotPassword': {
        return (
          <>
            <ForgotPasswordForm
              onLogin={this.handleLogin}
              redirectLink={redirectTo}
            />
          </>
        );
      }
      case 'MagicLink': {
        return (
          <>
            <MagicLinkForm
              onLogin={this.handleLogin}
              redirectLink={redirectTo}
            />
          </>
        );
      }
      default: {
        throw new Error('Invalid Case');
      }
    }
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer
});

export default connect(mapStateToProps, { getCustomer })(LoginForms);
